import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BaseLocalStorageService {
  constructor() {}

  setItem(key: string, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): unknown {
    return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clearEntireStorage(): void {
    localStorage.clear();
  }
}
